import { useEffect, useMemo, useState } from 'react'
import PowiatService from '@/services/PowiatService'

function formatPowiatLabel(item) {
	const powiatName = item?.nazwa || '-'
	const wojewodztwoName = item?.id_wojewodztwo?.nazwa || ''
	return wojewodztwoName ? `${powiatName} (${wojewodztwoName})` : powiatName
}

export default function usePowiatFilterModal(isOpen, selectedPowiatId, idWojewodztwo = null) {
	const [searchTerm, setSearchTerm] = useState('')
	const [items, setItems] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [activeId, setActiveId] = useState(selectedPowiatId || '')

	useEffect(() => {
		if (!isOpen) return
		setActiveId(selectedPowiatId || '')
	}, [isOpen, selectedPowiatId])

	useEffect(() => {
		if (!isOpen) return
		let cancelled = false
		const loadItems = async () => {
			setLoading(true)
			setError(null)
			const query = (searchTerm || '').trim()
			const options = {
				limit: 200,
				sortColumn: 'nazwa',
				sortDirection: 'asc',
				filters: idWojewodztwo ? { id_wojewodztwo: idWojewodztwo } : {},
			}
			const result = query ? await PowiatService.search(query, options) : await PowiatService.getAll(options)
			if (cancelled) return
			if (result?.error) {
				setError(result.error)
				setItems([])
			} else {
				setItems(Array.isArray(result?.data) ? result.data : [])
			}
			setLoading(false)
		}
		const timer = setTimeout(loadItems, 200)
		return () => {
			cancelled = true
			clearTimeout(timer)
		}
	}, [isOpen, searchTerm, idWojewodztwo])

	const selectedName = useMemo(() => {
		const selected = items.find(item => (item?._id || item?.id) === activeId)
		return selected ? formatPowiatLabel(selected) : ''
	}, [items, activeId])

	return {
		searchTerm,
		setSearchTerm,
		items,
		loading,
		error,
		activeId,
		setActiveId,
		selectedName,
		labelAccessor: formatPowiatLabel,
		clearFilter: () => setActiveId(''),
	}
}
